module.exports = __webpack_public_path__ + "img/account.70d9ec83.svg";